import { Grid, Typography } from '@mui/material';
import { Link } from '~/components/Link';

export default function NoResultsFound() {
  return (
    <Grid
      container
      item
      xs={true}
      className="right-column-no-results"
      pt={6}
      sx={{ transition: 'all 0.2s ease-in-out' }}
      alignContent={'start'}
      textAlign={'center'}>
      <Grid item xs={12} p={4}>
        <Typography variant="h4" textAlign={'center'}>
          No results found
        </Typography>
        <Typography variant="body1" textAlign={'center'} mt={1}>
          Try removing filters or adjusting your search.
          <br />
          <br />
          Need help? Email our team at{' '}
          <Link
            href="mailto:support@nerdydata.com"
            target="_blank"
            hideExternalIcon>
            support@nerdydata.com
          </Link>
        </Typography>
      </Grid>
      <Grid item xs={12} mt={4}>
        <img
          src={`${
            import.meta.env.VITE_STATIC_ASSETS_URL
          }/img/undraw_Golden_gate_bridge_jkph.svg`}
          alt="No results found"
          width={300}
        />
      </Grid>
    </Grid>
  );
}
